module.exports = __webpack_public_path__ + "img/green_053.69db890b.png";